import { NodeKind } from './internal-repr';
import { PredicateValue } from '@precon-tools-suite-by-shared/precon-graphql-types';

export const nodeKindSymbols: Record<NodeKind, string> = {
    [NodeKind.Value]: 'c',
    [NodeKind.Term]: 'P',
    [NodeKind.Conj]: '⋀',
    [NodeKind.Disj]: '⋁',
    [NodeKind.Neg]: '¬',
    [NodeKind.Implies]: '⇒',
    [NodeKind.Equiv]: '⇔',
};

export const predicateValueSymbols: Record<PredicateValue, string> = {
    [PredicateValue.Yes]: '⊤',
    [PredicateValue.No]: '⊥',
    [PredicateValue.Undecidable]: '⊬',
    [PredicateValue.Indeterminate]: '∅',
};
